<template>
  <!-- TOP Nav Bar -->
  <div class="iq-top-navbar">
    <div class="iq-navbar-custom" :class="horizontal ? 'd-flex align-items-center justify-content-between' : ''">
      <div class="iq-menu-horizontal" v-if="horizontal">
        <div class="iq-sidebar-menu">
          <List :items="items" class="d-flex"></List>
        </div>
      </div>
      <nav class="navbar navbar-expand-xs navbar-light flex-nowrap p-2 p-sm-1 mt-2">
        <slot name="left"/>
        <div class="iq-menu-bt d-flex align-items-center">
          <div class="wrapper-menu" @click="miniSidebar">
            <div class="main-circle"><i class="ri-menu-line"></i></div>
            <div class="hover-circle"><i id="open-menu-button" class="ri-close-fill"></i></div>
          </div>
          <div class="iq-navbar-logo justify-content-between ml-3 d-none d-sm-flex">
            <a href="#" class="header-logo">
              <span style="color:#ff5a00; font-weight: bold;">123</span><span style="margin: 0">GOM</span>
            </a>
          </div>
        </div>
        <slot name="responsiveRight" />
        <slot name="right" />
      </nav>
    </div>
  </div>
  <!-- TOP Nav Bar END -->
</template>
<script>
import List from '../menus/ListStyle1'
import SideBarItems from '../../../FackApi/json/SideBar'
import { mapGetters } from 'vuex'
export default {
  name: 'NavBarStyle1',
  props: {
    homeURL: { type: Object, default: () => ({ name: 'layout1.dashboard' }) },
    title: { type: String, default: 'Dashboard' },
    logo: { type: String, default: require('../../../assets/images/logo.png') },
    horizontal: { type: Boolean, default: false },
    items: { type: Array }
  },
  mounted () {
    document.addEventListener('click', this.closeSearch, true)

    let that = this
    window.onclick = function (event) {
      // close the menu
      that.$store.dispatch('Setting/miniSidebarAction', { forceClose: true })
      let wrapperMenu = document.querySelector('.wrapper-menu')
      let body = document.querySelector('body')
      wrapperMenu.classList.remove('open')
      body.classList.remove('sidebar-main')
    }
    document.querySelector('.iq-sidebar').addEventListener('click', (event) => {
      event.stopPropagation()
    })
    document.querySelector('.wrapper-menu').addEventListener('click', (event) => {
      event.stopPropagation()
    })
  },
  components: {
    List
  },
  computed: {
    ...mapGetters({
      bookmark: 'Setting/bookmarkState'
    })
  },
  data () {
    return {
      sidebar: SideBarItems,
      globalSearch: '',
      showSearch: false,
      showMenu: false
    }
  },
  methods: {
    miniSidebar () {
      this.$emit('toggle')
    }
  }
}
</script>
